import axios from 'axios';
import { BACKEND_URL, API_VERSION } from './environment_config';

/*-- Import required components --*/
import { store } from '../redux/store';
import { showMessageBox } from '../redux/actions/messageBoxActions';
import { resetRemainingTime } from '../redux/actions/sessionTimeoutActions';
import { showLoadingScreen, hideLoadingScreen } from '../redux/actions/loadingScreenActions';
import { local_logException } from './commonFunctions';

export const getHeaders = () => {
    const state = store.getState();
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'usersessionid': state.userDetails.userSessionID,
            'X-Frame-Options' : 'DENY'
        }
    };
};

// HTTP GET Request - Returns Resolved or Rejected Promise
export const get = (path, apiVersion) => {
    if (apiVersion) { apiVersion = apiVersion }
    else { apiVersion = API_VERSION }
    return new Promise((resolve, reject) => {
        axios.defaults.withCredentials = true;
        axios.get(`${BACKEND_URL}/${apiVersion}${path}`, getHeaders())
            .then(response => {
                store.dispatch(resetRemainingTime());
                resolve(response);
            })
            .catch(error => {
                console.error(error.message);
                window.sessionStorage.clear();
                store.dispatch(hideLoadingScreen());
                if (error.response === undefined) {
                    local_logException(error);
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: "Something went wrong. We're working on getting this fixed as soon as we can.\nYou may be able to try again.",
                        isConfirmation: false,
                        callBackFunction: () => { window.location.href = "/welcome" }//change
                    }
                    store.dispatch(showMessageBox(messageBox));
                }
                else if (error.response.status === 401) {
                    let messageBox = {
                        show: true,
                        title: "Your session expired!",
                        className: "warning",
                        content: "Sorry, your session has expired.",
                        isConfirmation: false,
                        callBackFunction: () => { window.location.href = "/welcome" }
                    }
                    store.dispatch(showMessageBox(messageBox));
                }
                else {
                    local_logException(error);
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: "Something went wrong. We're working on getting this fixed as soon as we can.\nYou may be able to try again.",
                        isConfirmation: false,
                        callBackFunction: () => { window.location.href = "/welcome" }//
                    }
                    store.dispatch(showMessageBox(messageBox));
                }
            });
    });
};

// HTTP POST Request - Returns Resolved or Rejected Promise
export const post = (path, data, apiVersion) => {
    if (apiVersion) { apiVersion = apiVersion }
    else { apiVersion = API_VERSION }
    return new Promise((resolve, reject) => {
        axios.defaults.withCredentials = true;
        axios.post(`${BACKEND_URL}/${apiVersion}${path}`, data, getHeaders())
            .then(response => {
                store.dispatch(resetRemainingTime());
                resolve(response);
            })
            .catch(error => {
                console.error(error.message);
                window.sessionStorage.clear();
                store.dispatch(hideLoadingScreen());
                if (error.response === undefined) {
                    local_logException(error);
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: "Something went wrong. We're working on getting this fixed as soon as we can.\nYou may be able to try again.",
                        isConfirmation: false,
                        callBackFunction: () => { window.location.href = "/welcome" }
                    }
                    store.dispatch(showMessageBox(messageBox));
                }
                else if (error.response.status === 401) {
                    let messageBox = {
                        show: true,
                        title: "Your session expired!",
                        className: "warning",
                        content: "Sorry, your session has expired.",
                        isConfirmation: false,
                        callBackFunction: () => { window.location.href = "/welcome" }
                    }
                    store.dispatch(showMessageBox(messageBox));
                }
                else {
                    local_logException(error);
                    let messageBox = {
                        show: true,
                        title: "Oops!",
                        className: "error",
                        content: "Something went wrong. We're working on getting this fixed as soon as we can.\nYou may be able to try again.",
                        isConfirmation: false,
                        callBackFunction: () => { window.location.href = "/welcome" }
                    }
                    store.dispatch(showMessageBox(messageBox));
                }
            });
    });
};